import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from './Icon.js';

var BadgeAlarmIcon = Icon(jsxs("g", { children: [jsx("circle", { cx: "8", cy: "8", r: "8" }), jsx("g", { transform: "translate(-3.33 -3.33) scale(1.33)", children: jsx("path", { fill: "white", d: "M10.543,5.6,8.6,7.543,6.658,5.6,5.6,6.658,7.543,8.6,5.6,10.543,6.658,11.6,8.6,9.658,10.543,11.6,11.6,10.543,9.658,8.6,11.6,6.658Z" }) })] }), '0 0 16 16', 'BadgeAlarmIcon');

export { BadgeAlarmIcon as default };
